<template>
  <div class="d-flex flex-column ga-1 py-1">
    <v-btn @mousedown="mousedown(1)" icon="mdi-chevron-up" variant="tonal" size="x-small" class="btn"></v-btn>
    <v-btn @mousedown="mousedown(-1)" icon="mdi-chevron-down" variant="tonal" size="x-small" class="btn"></v-btn>
  </div>
</template>

<script setup>
const count = defineModel()
const props = defineProps({
  min: [Number, String],
  max: [Number, String],
})
let interval
let timeout

const increment = (number) => {
  let value = +count.value + number
  if (props.min || props.min == 0) value = Math.max(value, props.min)
  if (props.max || props.max == 0) value = Math.min(value, props.max)
  count.value = value
}

const mousedown = (number) => {
  if (isNaN(count.value) && count.value !== null) return
  timeout = setTimeout(() => {
    interval = setInterval(() => {
      increment(number)
    }, 100)
  }, 250)
  increment(number)
  window.addEventListener('mouseup', mouseup)
}

const mouseup = () => {
  window.removeEventListener('mouseup', mouseup)
  clearTimeout(timeout)
  clearInterval(interval)
}
</script>

<style scoped>
.btn {
  height: 0.8rem;
  width: 2rem;
  border-radius: 4px;
}
</style>
